/*
Loads csv data for the practice and experiment trials. Renames columns, shuffles trials, as required. Sets the data to a struct and exports it as "corpus".
*/
import "../../../i18n/i18n";
import Papa from "papaparse"; //parsing csv file in browser
import "regenerator-runtime/runtime"; //async function
import katex from "katex"; //convert latex to markup
import store from "store2"; //storing session data

//takes array data and converts the labels for each row to a common naming convention
const transformCSV = (csvInput) =>
  csvInput.reduce((accum, row) => {
    const newRow = {
      itemID: row.ID,
      cc_grade_level: row.cc_grade_level,
      time_limit: parseInt(row.time_limit) * 1000, //convert to milliseconds
      countdown_time: parseInt(row.countdown_time),
      item_raw: row.item,
      version: row.version,
      image_height: row.image_height,
      response_format: row.response_format.split(","),
      lead_raw: row.lead ? row.lead.split(",") : [],
      textbox_width: row.textbox_width,
      target: row.target.toString().split(","),
    };

    if (row.after_item_ID) {
      newRow["after_item_ID"] = parseInt(row.after_item_ID);
    }

    if (typeof row.image == "string") {
      newRow["addImage"] = row.image.toLowerCase() === "true";
    } else {
      newRow["addImage"] = row.image;
    }

    accum.push(newRow);
    return accum;
  }, []);

const parseKatex = (currentStr) => {
  let split_string = currentStr.split("<k>");
  let parsedStr = "";

  for (let i = 0; i < split_string.length; i++) {
    if (split_string[i].includes("katex")) {
      split_string[i] = split_string[i].replace("katex", "");
      parsedStr += katex.renderToString(split_string[i], {
        throwOnError: false,
      });
    } else {
      parsedStr += split_string[i];
    }
  }

  return parsedStr;
};

export const fetchAndParseCorpusAlpaca = async (task, assets) => {
  let itemBank = {};
  let stimulusArray = [];
  let practiceStimulusArray = [];

  const corpusLocation = {
    stimulus: `https://storage.googleapis.com/roam-fluency/en/shared/corpora/alpaca/items.csv`,
    practice: `https://storage.googleapis.com/roam-fluency/en/shared/corpora/alpaca/items-practice.csv`,
  };

  //call the function for transforming item list
  function downloadLocalCSV(data, key) {
    return new Promise((resolve, reject) => {
      itemBank[key] = transformCSV(data);
      resolve(data);
    });
  }

  function downloadCSV(urls, key) {
    return new Promise((resolve, reject) => {
      Papa.parse(urls[key], {
        download: true,
        header: true,
        complete: function (results) {
          itemBank[key] = transformCSV(results.data);
          resolve(results.data);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  /*async function parseMultipleCSVs(urls) {
    const promises = urls.map((url, i) => downloadCSV(url, i));
    return Promise.all(promises);
  }*/

  //pass csv paths into the parsing function and set the number of trials in session data
  async function fetchData() {
    //const urls = [`https://storage.googleapis.com/roar-survey/en/CSV/${practiceCorpus}.csv`, `https://storage.googleapis.com/roar-survey/en/CSV/${stimulusCorpus}.csv`];

    //const urls =['../../task_data/morphology-surveyPractice.csv','../../task_data/morphology-items.csv']

    /*try {
      await downloadLocalCSV(csvArray["stimulus"]);
    } catch (error) {
      console.error("Error:", error);
    }

    try {
      await parseMultipleCSVsOrder(corpu["order"]);
    } catch (error) {
      console.error("Error:", error);
    }*/

    //get items array
    try {
      await downloadCSV(corpusLocation, "stimulus");
    } catch (error) {
      console.error("Error:", error);
    }

    //get practice array
    try {
      await downloadCSV(corpusLocation, "practice");
    } catch (error) {
      console.error("Error:", error);
    }

    /*try {
      await downloadLocalCSV(itemsAlpaca);
    } catch (error) {
      console.error("Error:", error);
    }

    try {
      await downloadLocalCSV(itemsAlpacaPractice);
    } catch (error) {
      console.error("Error:", error);
    }*/
  }

  await fetchData();

  let increment = store.session.get("config").itemVersions;
  for (let i = 0; i < itemBank["stimulus"].length; i += increment) {
    let randomIndex = Math.floor(
      Math.random() * store.session.get("config").itemVersions,
    );

    let current_item = itemBank["stimulus"][i + randomIndex];

    current_item["item"] = parseKatex(current_item["item_raw"]);

    if (current_item["addImage"]) {
      assets.default.languageSpecific.device.push(
        "alpaca" +
          current_item["itemID"] +
          "_" +
          current_item["version"] +
          ".png",
      );
    }
    current_item["lead"] = [];
    for (let j = 0; j < current_item["lead_raw"].length; j++) {
      current_item["lead"].push(
        katex.renderToString(current_item["lead_raw"][j], {
          throwOnError: false,
        }),
      );
    }
    current_item["countDownAppears"] =
      current_item["time_limit"] - current_item["countdown_time"] * 1000;
    current_item["countDownTimeString"] = ":" + current_item["countdown_time"];
    stimulusArray.push(current_item);
  }

  for (let i = 0; i < itemBank["practice"].length; i++) {
    let current_item = itemBank["practice"][i];
    current_item["item"] = parseKatex(current_item["item_raw"]);

    current_item["lead"] = [];
    for (let j = 0; j < current_item["lead_raw"].length; j++) {
      current_item["lead"].push(
        katex.renderToString(current_item["lead_raw"][j], {
          throwOnError: false,
        }),
      );
    }

    if (current_item["lead_raw"].length > 0) {
      current_item["demoNumbers"] = current_item["lead_raw"][0].replace(
        /[^0-9]/g,
        "",
      );
    }

    practiceStimulusArray.push(current_item);
  }

  //set trial data to a struct, set name for later referencing
  let corpusAll = {
    stimulus: stimulusArray,
    practice: practiceStimulusArray,
  };

  store.session.set("corpusAll", corpusAll);
  store.session.set("totalNumItems", stimulusArray.length);
  store.session.set("practiceItem", practiceStimulusArray[0]);
};
